import { get } from 'lodash-es';
import { DATA_PATH } from 'client/engagement-handlers/inventory-engagement-handler/constants';
import { isCarMax } from 'site-modules/shared/utils/dealer-details-utils';

/**
 * Returns status of CarMax 360
 * @param {object} vinData
 * @param {boolean} isBLT2125DisableCarmax360
 * @returns {boolean}
 */
export function isCarMax360Enabled(vinData, isBLT2125DisableCarmax360 = false) {
  return (
    isCarMax(get(vinData, DATA_PATH.PARENT_DEALERSHIP_NAME, '')) &&
    !!vinData.stockNumber &&
    (get(vinData, 'vehicleInfo.photo.photo360.CARMAX.hasExterior', false) ||
      get(vinData, 'vehicleInfo.photo.photo360.CARMAX.hasInterior', false)) &&
    !isBLT2125DisableCarmax360
  );
}
